import {
  SET_SELECTED_WORK_SCHEDULE,
  SET_WORK_SCHEDULES,
  SET_WORK_SCHEDULES_LOADED,
  SET_WORK_SCHEDULE_FILTER,
  WorkScheduleAction,
  WorkScheduleState,
} from '../types'

const initialState: WorkScheduleState = {
  workSchedules: [],
  isWorkSchedulesLoaded: false,
  workScheduleFilter: {
    employeeName: '',
    stationName: '',
    shiftName: '',
    startTime: '00:00',
    endTime: '23:59',
  },
}

export const workScheduleReducer = (
  state = initialState,
  action: WorkScheduleAction
): WorkScheduleState => {
  switch (action.type) {
    case SET_WORK_SCHEDULES:
      return {
        ...state,
        workSchedules: action.payload,
      }
    case SET_WORK_SCHEDULES_LOADED:
      return {
        ...state,
        isWorkSchedulesLoaded: action.payload,
      }
    case SET_SELECTED_WORK_SCHEDULE:
      return {
        ...state,
        selectedWorkSchedule: action.payload,
      }
    case SET_WORK_SCHEDULE_FILTER:
      return {
        ...state,
        workScheduleFilter: action.payload,
      }
    default:
      return state
  }
}
